import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M28.334 15.832l-6.558 6.557c-.33.33-.495.495-.685.557a.835.835 0 01-.515 0c-.19-.062-.355-.227-.685-.557l-2.281-2.28c-.33-.33-.495-.496-.686-.558a.833.833 0 00-.514 0c-.19.062-.356.227-.686.557l-4.057 4.057m16.667-8.333H22.5m5.834 0v5.833"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent